// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__kcOlq","noInteraction":"EventWrapper_noInteraction__1_F7b","pointerPassthrough":"EventWrapper_pointerPassthrough__28yfX"};